import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  Button
} from '@mui/material';

interface CancelTripDialogProps {
  open: boolean;
  cancelling: boolean;
  cancelReason: string;
  cancelReasonOther: string;
  cancelNotes: string;
  cancelFormTouched: boolean;
  cancellationReasons: string[];
  onClose: () => void;
  onReasonChange: (reason: string) => void;
  onReasonOtherChange: (reasonOther: string) => void;
  onNotesChange: (notes: string) => void;
  onConfirm: () => void;
}

const CancelTripDialog: React.FC<CancelTripDialogProps> = ({
  open,
  cancelling,
  cancelReason,
  cancelReasonOther,
  cancelNotes,
  cancelFormTouched,
  cancellationReasons,
  onClose,
  onReasonChange,
  onReasonOtherChange,
  onNotesChange,
  onConfirm
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    aria-labelledby="cancel-trip-dialog-title"
    aria-describedby="cancel-trip-dialog-description"
    fullWidth
    maxWidth="sm"
  >
    <DialogTitle id="cancel-trip-dialog-title">
      Cancel Trip
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="cancel-trip-dialog-description" sx={{ mb: 2 }}>
        Please provide a reason for cancelling this trip. This action cannot be undone.
      </DialogContentText>
      <FormControl
        fullWidth
        required
        error={cancelFormTouched && !cancelReason}
        sx={{ mb: 2 }}
      >
        <InputLabel id="cancel-reason-label">Cancellation Reason</InputLabel>
        <Select
          labelId="cancel-reason-label"
          id="cancel-reason"
          value={cancelReason}
          label="Cancellation Reason"
          onChange={(e) => {
            onReasonChange(e.target.value);
          }}
          autoFocus
        >
          {cancellationReasons.map((reason) => (
            <MenuItem key={reason} value={reason}>{reason}</MenuItem>
          ))}
        </Select>
        {cancelFormTouched && !cancelReason && (
          <FormHelperText>Please select a reason</FormHelperText>
        )}
      </FormControl>
      {cancelReason === 'Other' && (
        <TextField
          margin="dense"
          id="cancel-reason-other"
          label="Specify Reason"
          type="text"
          fullWidth
          required
          value={cancelReasonOther}
          onChange={(e) => onReasonOtherChange(e.target.value)}
          error={cancelFormTouched && !cancelReasonOther.trim()}
          helperText={cancelFormTouched && !cancelReasonOther.trim() ? 'Custom reason is required' : ''}
          sx={{ mb: 2 }}
        />
      )}
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        disabled={cancelling}
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={cancelling || !cancelReason || (cancelReason === 'Other' && !cancelReasonOther.trim())}
      >
        {cancelling ? 'Processing...' : 'Confirm Cancellation'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default CancelTripDialog;